import { createFileRoute, redirect } from '@tanstack/react-router';
import { seoHead } from '@/lib/seoHead';
import { comparisonQuery, ComparisonDetail } from '@/components/comparison/ComparisonPages';
import { ComparisonError } from '@/components/comparison/ComparisonError';

// Endereço antigo (por código): redireciona permanentemente para /produto/{nome}.
export const Route = createFileRoute('/comparador-de-precos/$id')({
  loader: async ({ context, params }) => {
    const d = await context.queryClient.ensureQueryData(comparisonQuery({ id: params.id }));
    if (d.productSlug) throw redirect({ to: '/produto/$slug', params: { slug: d.productSlug }, statusCode: 301 });
    return d;
  },
  head: () => seoHead({ title: 'Comparação indisponível | Shopping do Bem', description: 'Este produto não possui ofertas verificadas suficientes no momento.', noindex: true }),
  component: () => <ComparisonDetail id={Route.useParams().id} />,
  errorComponent: ({ reset }) => <ComparisonError reset={reset} />,
});
